import React, { useMemo } from 'react';
import { createStore, Provider } from 'jotai';
import * as atoms from '../utils/atom';
import { noop } from 'lodash';

const useInitStore = (props: atoms.ManagementProps) => {
  const { dimensionMeta, dimensionsData, onClose = noop, onEdit = noop } = props;

  const store = useMemo(() => {
    const newStore = createStore();
    newStore.set(atoms.isLoading, false);
    newStore.set(atoms.DimensionAdded, 0);
    newStore.set(atoms.dimensionMeta, dimensionMeta);
    newStore.set(atoms.dimensionsData, dimensionsData);
    newStore.set(atoms.callbacks, {
      onClose,
      onEdit,
    });

    return newStore;
  }, [dimensionMeta, dimensionsData, onClose, onEdit]);

  return store; // Return the initialized store
};

export const ManagementProvider = (
  props: atoms.ManagementProps & { children: React.ReactNode },
) => {
  const store = useInitStore(props); // Get the initialized store
  return <Provider store={store}>{props.children}</Provider>; // Provide the store to children
};
